import { useRef, useEffect } from "react";

function MultilineInput({ input, setInput, sendMessage }) {
  const textareaRef = useRef(null);

  // Effect to auto-expand when input prop changes (e.g. from external state updates)
  useEffect(() => {
    if (textareaRef.current) {
      autoExpand(textareaRef.current);
    }
  }, [input]);

  const handleChange = (e) => {
    setInput(e.target.value);
    autoExpand(e.target);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (e.shiftKey) {
        // Shift+Enter already adds a new line in textarea, no need to manually add it
      } else {
        e.preventDefault();
        sendMessage();
        setInput(""); // Clear input after sending
        // Reset height to default
        if (textareaRef.current) {
          textareaRef.current.style.height = "auto";
        }
      }
    }
  };

  const autoExpand = (element) => {
    element.style.height = "auto"; // Reset height
    element.style.height = `${element.scrollHeight}px`; // Adjust height dynamically
  };

  return (
    <textarea
      ref={textareaRef}
      style={{
        flex: 1,
        padding: "0.75rem",
        border: "1px solid #d1d5db",
        borderRadius: "0.375rem",
        outline: "none",
        fontSize: "0.875rem",
        whiteSpace: "pre-wrap",
        overflowWrap: "break-word",
        resize: "none", // Prevent manual resizing
        overflow: "hidden", // Hide scrollbar
        height: "auto",
        minHeight: "40px",
        display: "block",
        lineHeight: "1.5",
        fontFamily: "inherit",
      }}
      placeholder="Ask about material requests, status updates, etc..."
      value={input}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      rows={1} // Start with one row
    />
  );
}

export default MultilineInput;